import FormText from 'components/form/FormText';
import type { FieldErrors, UseFormRegister } from 'react-hook-form';
import type { SignupFormStateType } from '../SignupIndex';

import type { JSX } from 'react';

export function SignupUserSection({
  register,
  errors,
}: {
  register: UseFormRegister<SignupFormStateType>;
  errors: FieldErrors<SignupFormStateType>;
}): JSX.Element {
  return (
    <>
      <div className="mt-1">
        <div className="row justify-content-center">
          <div className="row form-row flex-md-row justify-content-between">
            <div className="column col-12">
              <h3 className="title-section title-md fw-bold mb-3">ユーザー情報</h3>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="row form-row flex-md-row justify-content-between">
          <div className="column col-lg-6 col-xl-6 col-left">
            <FormText
              subject="メールアドレス"
              name="mailAddress"
              placeholder="example@example.com"
              register={register}
              errors={errors}
              required={true}
              maxLength={300}
              format="email"
              requiredMark={true}
            />
          </div>
          <div className="column col-lg-6 col-xl-6 col-right">
            <FormText
              subject="氏名"
              name="fullName"
              placeholder="山田 太郎"
              register={register}
              errors={errors}
              required={true}
              maxLength={100}
              requiredMark={true}
            />
          </div>
        </div>
      </div>
    </>
  );
}
